export default "__VITE_ASSET__BkYfo1OA__"